import Vue from 'vue'
import momentTZ from 'moment-timezone'
import TimeAgo from 'javascript-time-ago'
import fa from 'javascript-time-ago/locale/fa.json'
import en from 'javascript-time-ago/locale/en.json'
import moment from 'jalali-moment'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import axios from 'axios'
import store from '@/store'
import deviceService from '@/services/device.service'
// eslint-disable-next-line import/no-cycle
import { i18n } from '@/main'
import authHeader from '@/services/auth-header'
import Config from '../config'

TimeAgo.addLocale(en)
TimeAgo.addLocale(fa)

export const functions = {
  currentLangDirection() {
    // alert(`Dir = ${i18n.messages[Vue.prototype.defaultLanguage].direction}`)
    return i18n.messages[Vue.prototype.defaultLanguage].direction
  },
  isMobile() {
    const currentBreakpointValue = store.getters['app/currentBreakPoint']
    if (currentBreakpointValue === 'xs' || currentBreakpointValue === 'sm') {
      return true
    }
    return false
  },
  // Array of imeis ["1236520...", ...]
  getMobileSelectedDevices() {
    const data = localStorage.getItem('mobileSelectedDevices')
    if (data) {
      return JSON.parse(data)
    }
    return []
  },
  setMobileSelectedDevices(arr) {
    localStorage.setItem('mobileSelectedDevices', JSON.stringify(arr))
    Vue.prototype.$mobileSelectedDevices = arr
  },
  // این تابع بررسی میکند که در صورت ورود با موبایل آیا imei ورودی جز موارد انتخابی
  // هست یا خیر که در صورت نبودن false بر میگرداند
  // برای حالت دسکتاپ همیشه true است
  checkImeiInSelectedList(imei) {
    if (this.isMobile()) {
      if (Vue.prototype.$mobileSelectedDevices.indexOf(imei) > -1) {
        return true
      }
      return false
    }
    return true
  },
  getMapLimit() {
    if (this.isMobile()) {
      return 20
    }
    return 99999999
  },
  /**
   * Safely extracts latitude and longitude from serverInfo
   * Handles different data formats: lat/lon, latitude/longitude, and $numberDecimal
   * @param {Object} serverInfo - The serverInfo object from device
   * @returns {Object|null} - { lat, lng } or null if invalid
   */
  getLatLngFromServerInfo(serverInfo) {
    if (!serverInfo) return null

    let lat = null
    let lng = null

    // Format 1: lat/lon properties
    if (typeof serverInfo.lat !== 'undefined' && serverInfo.lat !== null) {
      lat = parseFloat(serverInfo.lat)
      lng = parseFloat(serverInfo.lon)
    // Format 2: latitude/longitude with $numberDecimal (MongoDB Decimal128)
    } else if (typeof serverInfo.latitude !== 'undefined' && serverInfo.latitude !== null) {
      if (typeof serverInfo.latitude === 'object' && serverInfo.latitude.$numberDecimal) {
        lat = parseFloat(serverInfo.latitude.$numberDecimal)
        lng = parseFloat(serverInfo.longitude.$numberDecimal)
      } else {
        // Format 3: Direct latitude/longitude numbers
        lat = parseFloat(serverInfo.latitude)
        lng = parseFloat(serverInfo.longitude)
      }
    }

    // Validate coordinates
    if (lat === null || lng === null || Number.isNaN(lat) || Number.isNaN(lng)) {
      return null
    }
    // Check for invalid coordinates (0,0 is technically valid but often means no data)
    if (lat === 0 && lng === 0) {
      return null
    }

    return { lat, lng }
  },
  time() {
    const now = momentTZ.tz(new Date(), 'Asia/Tehran')
    return Math.ceil(now / 1000)
  },
  timeSince(unixtime) {
    if (typeof unixtime === 'number' && unixtime > 1000000000) {
      // eslint-disable-next-line no-param-reassign
      //   if(new Date() < unixtime * 1000) unixtime = Date() / 1000
      const timeAgo = new TimeAgo(i18n.messages[Vue.prototype.defaultLanguage]['lang-country'])
      return timeAgo.format((unixtime - 1) * 1000, 'round')
    }
    return i18n.messages[Vue.prototype.defaultLanguage]['A while ago']
  },
  unixToPersianDate(unixtime) {
    // بررسی مقادیر نامعتبر - اگر unixtime صفر، null، undefined یا کمتر از 1000 باشه، رشته خالی برگردون
    if (!unixtime || unixtime < 1000) {
      return ''
    }
    return moment(unixtime * 1000)
      .locale('fa')
      .format('YYYY/M/D  H:mm:ss')
  },
  unixToPersianDateS(unixtime) {
    if (!unixtime || unixtime < 1000) {
      return ''
    }
    return moment(unixtime * 1000)
      .locale('fa')
      .format('YYYY/M/D')
  },
  unixToPersianTime(unixtime) {
    if (!unixtime || unixtime < 1000) {
      return ''
    }
    return moment(unixtime * 1000)
      .locale('fa')
      .format('h:m:s')
  },
  todayTimes() {
    const start = new Date(this.time() * 1000)
    start.setHours(0, 0, 0, 0)

    const end = new Date()
    end.setHours(23, 59, 59, 0)

    return {
      start: start / 1000,
      end: end / 1000,
    }
  },
  lastDaysTimes(day) {
    const todayTimes = this.todayTimes()
    return {
      start: moment(todayTimes.start * 1000 - (day * 24 * 3600 * 1000))
        .unix(),
      end: todayTimes.end,
    }
  },
  fixNumbers: str => {
    const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g]
    const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g]
    if (typeof str === 'string') {
      for (let i = 0; i < 10; i++) {
        // eslint-disable-next-line no-param-reassign
        str = str.replaceAll(persianNumbers[i], i)
          .replaceAll(arabicNumbers[i], i)
      }
    }
    return str
  },
  toFaNumbers: str => {
    const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']
    const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g]
    if (typeof str === 'string') {
      for (let i = 0; i < 10; i++) {
        // eslint-disable-next-line no-param-reassign
        str = str.replaceAll(i, persianNumbers[i])
          .replaceAll(arabicNumbers[i], persianNumbers[i])
      }
    }
    return str
  },
  toEnNumbers: str => {
    const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹']
    const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g]
    if (typeof str === 'string') {
      for (let i = 0; i < 10; i++) {
        // eslint-disable-next-line no-param-reassign
        str = str.replaceAll(persianNumbers[i], i)
          .replaceAll(arabicNumbers[i], i)
      }
    }
    return str
  },
  getDeviceIndex(imei) {
    for (let i = 0; i <= Vue.prototype.$devices.length - 1; i += 1) {
      if (Vue.prototype.$devices[i].imei === imei) {
        return i
      }
    }
    return null
  },
  getDeviceIndex2(devices, imei) {
    let i = 0
    Object.keys(devices)
    // eslint-disable-next-line consistent-return
      .forEach(index => {
        if (index === imei) {
          return i
        }
        i += 1
      })

    return i
  },
  getDeviceInfo(imei) {
    for (let i = 0; i <= Vue.prototype.$devices.length - 1; i += 1) {
      if (Vue.prototype.$devices[i].imei === imei) {
        Vue.prototype.$devices[i].$index = i
        return Vue.prototype.$devices[i]
      }
    }
    return null
  },
  fixDeviceInfo(device) {
    let data = device
    if (!data) {
      data = {
        userId: {
          name: '',
          family: '',
        },
        serverInfo: { servertime: 0 },
      }
    }
    if (!('userId' in data)) {
      data.userId = {
        name: '',
        family: '',
      }
    }
    if (!('serverInfo' in data)) {
      data.serverInfo = { servertime: 0 }
    }
    if (!('serverStatus' in data)) {
      data.serverStatus = { gsmSigStrength: 0, voltageLevel: 0, terminalInfo: { ignition: false, charging: false, gpsTracking: false } }
    }
    return data
  },
  searchInDevices(q) {
    let devices
    if (q && Vue.prototype.$devices.length > 0) {
      devices = Vue.prototype.$devices.filter(item => q.toLowerCase()
        .split(' ')
        .every(v => item.imei.toLowerCase()
          .includes(v) || item.title.toLowerCase()
          .includes(v)))
    } else {
      devices = Vue.prototype.$devices
    }
    return devices
  },
  checkExpire(device) {
    const todey = moment(this.time() * 1000)
      .locale('fa')
      .format('YYYYMMDD')

    if (device.expireTime) {
      // خودِ روز انقضا هنوز معتبر است؛ دستگاه از روز بعد منقضی می‌شود.
      // قبلا مقایسه «بزرگ‌تر» بود و دستگاه یک روز زودتر منقضی می‌شد و چون
      // رویدادهای devicePosition/deviceStatus برای دستگاه منقضی نادیده گرفته
      // می‌شوند، نقشه در روز آخر اشتراک بی‌دلیل خالی می‌ماند.
      // معیار یکسان با DeviceAll.vue و utils/deviceFilters.js.
      if (device.expireTime.replaceAll('/', '') >= todey) {
        return true
      }
    } else {
      return true
    }
    return false
  },
  fillDevices() {
    // در این حالت باید حالت انتخابی برداشته شده
    // و مبنای نمایش بر اساس کلیک بر روی هر یک از
    // مارکرها باشد
    Vue.prototype.$mobileSelectedDevices = this.getMobileSelectedDevices()

    return deviceService.getList()
      .then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result) {
              Vue.prototype.$devices = res.result.data
              // در صورتی که لیست پیشفرض انتخاب نشده بود در حالت موبایل
              // اولین دستگاه بعنوان پیشفرض انتخابی در نظر گرفته می شود
              if (this.isMobile() && Vue.prototype.$mobileSelectedDevices.length <= 0) {
                this.setMobileSelectedDevices([Vue.prototype.$devices[0].imei])
                // this.checkSelectedDevices()
              }

              const imeis = []
              for (let i = 0; i <= Vue.prototype.$devices.length - 1; i += 1) {
                // پیشفرض همه غیر فعال هستند
                Vue.prototype.$devices[i].onlineStatus = 'offlineSymbol'

                if (this.checkExpire(Vue.prototype.$devices[i])) {
                  Vue.prototype.$devices[i].expire = false
                } else {
                  Vue.prototype.$devices[i].expire = true
                }
                imeis.push(Vue.prototype.$devices[i].imei)
              }

              // در این وضعیت از رم سرور خوانده می شود و دیتابیس درگیر نمی شود برای سرعت بیشتر
              return deviceService.getPositions({
                imeis,
                fromDate: 0,
                toDate: 0,
                limit: 1,
                sortItems: [{
                  name: 'servertime',
                  desc: true,
                }],
              })
                .then(
                  resp => {
                    if (resp.status === 'success') {
                      if ('result' in resp) {
                        for (const imei in resp.result) {
                          if (resp.result[imei].length > 0) {
                            const deviceIndex = this.getDeviceIndex(imei)
                            if (deviceIndex === null || !Vue.prototype.$devices[deviceIndex]) continue

                            if (resp.result[imei][0].lastStatus) {
                              Vue.prototype.$devices[deviceIndex].serverStatus = resp.result[imei][0].lastStatus
                            }
                            // eslint-disable-next-line no-param-reassign
                            delete resp.result[imei][0].lastStatus

                            // eslint-disable-next-line prefer-destructuring
                            Vue.prototype.$devices[deviceIndex].serverInfo = resp.result[imei][0]
                          }
                        }
                        // چون تایمر برای اولین بررسی زمان میبرد برای بار اول
                        // درخواست وضعیت میکنیم بلافاصله
                        Vue.prototype.$socket.emit('devicesOnlineTime', {})
                      }
                    }
                  },
                  error => {
                    const errorMessage = (error.response && error.response.data)
                      || error.message
                      || error.toString()
                    if (Vue.prototype.$toast) {
                      Vue.prototype.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'پیام',
                          text: errorMessage,
                          icon: 'XIcon',
                          variant: 'danger',
                        },
                      })
                    }
                  },
                )
            }
          }
        },
        error => {
          const errorMessage = (error.response && error.response.data)
            || error.message
            || error.toString()
          if (Vue.prototype.$toast) {
            Vue.prototype.$toast({
              component: ToastificationContent,
              props: {
                title: 'پیام',
                text: errorMessage,
                icon: 'XIcon',
                variant: 'danger',
              },
            })
          }
        },
      )
  },
  getFullAddress(latlon, imei) {
    const apiUrl = Config.apiServers.url
    return new Promise((resolve, reject) => {
      axios.get(`${apiUrl}/user/device/address`, {
        params: {
          lat: latlon.latitude,
          lng: latlon.longitude,
          imei: imei || 'unknown',
        },
        headers: authHeader(),
        timeout: 15000,
      })
        .then(res => {
          if (res.data && res.data.status === 'success' && res.data.result) {
            resolve(res.data.result.formatted_address)
          } else {
            reject(new Error(res.data.message || 'آدرسی یافت نشد'))
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  updateAddress(latlon) {
    return new Promise((resolve, reject) => {
      axios.get(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latlon.latitude}&lon=${latlon.longitude}`, { headers: { 'Accept-Language': 'fa' } })
        .then(data => {
          if (data.data.address.city === undefined) {
            resolve(`${data.data.address.town}، ${data.data.address.road}`)
          } else {
            resolve(`${data.data.address.city}، ${data.data.address.road}`)
          }
        }).catch(err => {
          reject(err)
        })
    })
  },
  getStatusMovement(imei) {
    // مرحله 1: بررسی وجود دستگاه
    if (this.getDeviceInfo(imei) === undefined) return 'offline'
    const deviceInfo = this.getDeviceInfo(imei)
    if (deviceInfo == null) return 'offline'

    // مرحله 2: بررسی وجود فیلدهای ضروری
    if (typeof deviceInfo.serverInfo === 'undefined') return 'offline'
    if (typeof deviceInfo.serverInfo.speed === 'undefined') return 'offline'
    if (typeof deviceInfo.serverStatus === 'undefined') return 'offline'
    if (typeof deviceInfo.serverStatus.terminalInfo === 'undefined') return 'offline'

    // مرحله 3: بررسی زمان آخرین داده - مستقیماً بررسی می‌کنیم
    if (deviceInfo.serverInfo.servertime) {
      const currentTime = this.time()
      const timeDiff = currentTime - deviceInfo.serverInfo.servertime
      
      // اگر بیش از 2 ساعت (7200 ثانیه) از آخرین داده گذشته، آفلاین است
      if (timeDiff > 2 * 60 * 60) {
        return 'offline' // دستگاه آفلاین است - بیش از 2 ساعت داده ارسال نکرده
      }
    } else {
      // اگر اصلاً زمانی ثبت نشده، آفلاین است
      return 'offline'
    }

    // مرحله 4: بررسی وضعیت ignition (سوئیچ ماشین) و سرعت
    const { ignition } = deviceInfo.serverStatus.terminalInfo
    const { speed } = deviceInfo.serverInfo

    // حالت 1: در حرکت - سرعت بیشتر از 2 کیلومتر (برای حذف نویز GPS)
    if (speed > 2) {
      return 'move' // ماشین در حال حرکت است
    }

    // حالت 2: روشن اما متوقف - سوئیچ باز و سرعت کم/صفر
    if (ignition === true && speed <= 2) {
      return 'on' // ماشین روشن اما متوقف است (مثلاً در ترافیک یا پارک موقت)
    }

    // حالت 3: خاموش - سوئیچ بسته و سرعت صفر
    // دستگاه GPS هنوز داده می‌فرستد ولی ماشین خاموش است
    if (ignition === false && speed <= 2) {
      return 'stop' // ماشین خاموش است (پارک شده)
    }

    // حالت پیش‌فرض (نباید برسد اینجا)
    return 'stop'
  },
  deviceServerSocketReconnect(callback) {
    Vue.prototype.$socket.disconnect(true)
    setTimeout(async () => {
      await Vue.prototype.$socket.connect()
      callback()
    }, 500)
  },
  setImeiForSocket(imeis) {
    const listAllow = []
    /*
    Object.keys(imeis)
        .forEach(index => {
          if(imeis[index] === true)
            listAllow.push(index)
        })
*/
    if (localStorage.getItem('gpsServers')) {
      Vue.prototype.$gpsServers = JSON.parse(localStorage.getItem('gpsServers'))
    } else {
      Vue.prototype.$gpsServers = Config.gpsServers
    }
    const promise = axios.post(`${Vue.prototype.$gpsServers.server1.url}/device/set-imeis-for-socket`, {
      imeis: listAllow,
    }, { headers: authHeader() })
    return promise.then(response => response.data)
  },
}
